<template>
  <div class="container visitReportSpDetail">
    <div class="searchBox">
      <div class="searchBox_top">
        <template v-if="showButton">
          <el-button size="mini" type="primary" v-acl="Spmsv-reportSave" @click="saveVisit('queryCondition')">{{$t('visitPlan.draftSave')}}</el-button>
          <el-button size="mini" type="primary" v-acl="Spmsv-reportSubmit" @click="submitVisitPlan('queryCondition')">{{$t('common.submit')}}</el-button>
        </template>
        <el-button size="mini" type="primary" @click="goBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
        <template v-if="showButton" v-acl="Spmsv-reportSave">
          <br />
          <label style="font-size:12px;color:#F56C6C;">{{$t('visitPlan.operationTips')}}</label>
        </template>
      </div>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>MSV Basic Info</span>
      </div>
      <el-form :model="queryCondition" ref="queryCondition" :rules="queryConditionRules" inline label-width="255px">
        <el-form-item label="MSV 单据编号" prop="msvNo">
          <!--计划单据编号-->
          <el-input v-model.trim="queryCondition.msvNo" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('visitPlan.Year')" prop="year">
          <!--拜访年份-->
          <el-input v-model="queryCondition.year" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('visitPlan.Type')" prop="type">
          <!--供应商类型-->
          <el-select v-model="queryCondition.type" disabled>
            <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('visitPlan.Category')" prop="category">
          <!--类型-->
          <el-select v-model="queryCondition.category" disabled>
            <el-option value="1">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="tmSupplierId">
          <!--供应商工厂-->
          <el-input disabled v-model="queryCondition.plantName"></el-input>
          <!-- <el-input v-model="queryCondition.tmSupplierId" disabled></el-input> -->
        </el-form-item>
        <el-form-item :label="$t('visitPlan.ReportBy')" prop="createBy">
          <el-input v-model="createBy" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('visitPlan.CreateDate')" prop="dataArr">
          <!--创建时间-->
          <el-date-picker type="date" v-model="queryCondition.createDate" placeholder="选择日期" disabled></el-date-picker>
        </el-form-item>
        <el-form-item label="Visit Type" prop="visitType">
          <el-select v-model="queryCondition.visitType" disabled>
            <el-option :key="index" v-for="(item,index) in visitTypeList" :label="item.chineseValue" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Report to（Supplier）" prop="supplierEmail">
          <el-input v-model="queryCondition.supplierEmail" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="Report to（McD）" prop="mcdEmail">
          <el-input v-model="queryCondition.mcdEmail" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="Attendees Supplier" prop="attendeesSupplier">
          <el-input v-model="queryCondition.attendeesSupplier" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="Attendees McDonald’s(& On behalf)" prop="attendeesMcd">
          <el-input v-model="queryCondition.attendeesMcd" disabled type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="Mgt. recap" prop="mgtRecap">
          <el-select v-model="queryCondition.mgtRecap" disabled>
            <el-option :key="index" v-for="(item,index) in mgtRecapList" :label="item.chineseValue" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="MSV Result" prop="msvResult">
          <el-select v-model="queryCondition.msvResult" disabled>
            <el-option :key="index" v-for="(item,index) in msvResultList" :label="item.chineseValue" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item label="On-site observations Number"></el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="High Risk" prop="highScore" class="highScoreClass">
            <el-input v-model="queryCondition.highScore" clearable type="number" disabled></el-input>
          </el-form-item>
          <el-form-item label="Medium Risk" prop="mediumScore" class="ScoreClass">
            <el-input v-model="queryCondition.mediumScore" clearable type="number" disabled></el-input>
          </el-form-item>
          <el-form-item label="Low Risk" prop="lowScore" class="ScoreClass">
            <el-input v-model="queryCondition.lowScore" clearable type="number" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-form-item label="拜访日期" prop="dataArr">
          <el-date-picker v-model="dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" disabled></el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="tableList" ref="tableList" border fit class="purposeList">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip prop="visitPurpose" label="拜访目的">
          <template slot-scope="scope">
            <el-autocomplete class="inline-input" disabled v-model="scope.row.visitPurpose" :fetch-suggestions="querySearch" placeholder="请输入内容">
            </el-autocomplete>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-tabs v-model="activeName">
      <el-tab-pane label="CQS附件" name="first">
        <el-table :data="fileList" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
            <!--文件-->
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadFileFDP(scope.row)">{{scope.row.documentName}} </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="供应商附件" name="second">
        <el-table :data="fileList2" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
            <template slot-scope="scope">
              {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="tmDocumentId" min-width="130px" v-if="isdeleteFile">
            <template slot-scope="scope">
              <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList2,scope.row)">{{$t('common.del')}}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="showButton">
          <div class="toolsBox">
            <!-- <el-button type="primary" size="small">全选</el-button>
          <el-button type="primary" size="small" >反选</el-button> -->
            <el-button type="primary" size="small" @click="submitUpload()">上传到服务器</el-button>
            <!-- <el-button type="primary" size="small" >下载</el-button> -->
          </div>
          <el-divider></el-divider>

          <div class="block">
            <span class="tip">上传文件说明:</span>
          </div>
          <div class="tipText">
            <span>* 请填写附件对应的发现项内容描述！</span>
            <span>*上传文件支持PDF，Excel，Word，.JPG，.PNG, .ZIP, .7Z</span>
          </div>
          <div class="uploadBox">
            <el-upload style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" multiple :before-remove="beforeRemove" :on-remove="removeFile" list-type="picture-card" :file-list="uploadFileList" name="file">
              <div slot="file" slot-scope="{file}" style="height:100%">
                <!-- <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                > -->
                <span class="fileName">{{file.name}}</span>
                <span class="el-upload-list__item-actions">
                  <!-- <span
                  class="el-upload-list__item-delete"
                  @click="downloadFile(file)"
                >
                  <i class="el-icon-download"></i>
                </span> -->
                  <span class="el-upload-list__item-delete" @click="removeFile(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                <!-- <el-input @input='miaoahuChange(file)' v-model="file.docComments" placeholder="描述"></el-input> -->
                <input type="text" v-model="file.docComments" placeholder="描述" @input="miaoahuChange(file)" class="miaoshu">
              </div>
              <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              <!--选取文件-->
              <!-- <el-input v-for="(item,index) of uploadFileList" :key="index" v-model="uploadFileListMiaoshu[index]" placeholder="描述"></el-input> -->

            </el-upload>
          </div>
        </template>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  saveSP,
  submitSP,
  getVisitReportList,
  saveReport,
  addVisitPlanReportInit,
  submitReport,
  reportDetail,
  saveMsvReportFileLogs,
  visitPlanDetailAddSeach
} from "@/api/visitPlan.js";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils";

import { Message } from "element-ui";
export default {
  name: "",
  components: {},
  data() {
    return {
      uploadFileListMiaoshu: [],
      ttMsvReportId: '',
      uploadFileList: [],
      activeName: "first",
      dataArr: [],
      totalCount: 0,
      tableList: [],
      riskLevelList: "",
      queryCondition: { pageSize: 15, pageNum: 1 },
      addPlanDetailsForm: {
        type: "Food"
      },
      showButton: true,
      showAccessories: false,
      rows: [],
      Categorylevel: true,
      typeList: [],
      visitTypeList: [],
      mgtRecapList: [],
      msvResultList: [],
      visitPurposeList: [],
      addPlanDetailsTable: [],
      capImplementationStatusList: [],
      queryConditionRules: {

      },
      //弹框中的字段
      detailAddform: { pageSize: 15, pageNum: 1, categoryLevel1Name: "Food" },
      tableList2: [],
      fileList: [],
      fileList2: [],
      isdeleteFile: true,
    };
  },
  computed: {
    selection() {
      return this.$refs.table.selection;
    }
  },
  created() {
    this.createBy = localStorage.getItem("ms_username")
    this.ttMsvReportId = this.$route.query.ttMsvReportId;
    this.getDetail(this.$route.query.ttMsvReportId)
    this.getFiles()
    this.getFiles2()
    this.getInputChoiceValues();
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.visitPurposeList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    downloadFileFDP: function (row) {
      fileService.downloadFileFDP(row, row.tmDocumentId, this.ttMsvReportId).then(res => { });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files, row) {
      let that = this
      fileService.deleteFile(tmDocumentId).then((res) => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess"),
        });
        //删除成功删除列表数据
        // files.splice(index, 1);
        let data = [
          {
            fileName: row.documentName,
            msvNo: that.queryCondition.msvNo,
            operate: 'DELETE',
            ttMsvReportId: that.ttMsvReportId,
          }
        ]
        console.log(data)
        saveMsvReportFileLogs(data).then(FileLogs => {
          console.log(FileLogs)
        });
        that.getFiles2()
      })
    },
    //删除前事件，为了控制点击键盘detele
    beforeRemove(file, fileList) {
      console.log("删除前事件")
      return false;
    },
    removeFile: function (file) {
      for (let j = 0; j < this.uploadFileList.length; j++) {
        if (this.uploadFileList[j].uid == file.uid) {
          this.uploadFileList.splice(j, 1)
        }
      }
    },
    miaoahuChange(v) {
      let that = this
      let uid = v.uid
      for (let i = 0; i < that.uploadFileList.length; i++) {
        if (that.uploadFileList[i].uid == uid) {
          that.uploadFileList[i].docComments = v.docComments
        }
      }
    },
    //文件上传
    submitUpload: function (supId, ix) {
      let _this = this;
      if (_this.uploadFileList.length < 1) {
        _this.$message({
          type: "error",
          // message:_this.$t("visitPlan.selectFile")
          message: "请先选择文件"
        });
        return;
      }
      for (let i = 0; i < _this.uploadFileList.length; i++) {
        if (_this.uploadFileList[i].type.indexOf('image') != -1) {//是图片
          if (_this.uploadFileList[i].docComments == '') {
            _this.$message({
              type: "error",
              message: "图片描述必填"
            });
            return;
          }
        }
      }
      let formData = new FormData();
      this.uploadFileList.forEach((item) => {
        // if(item.docComments!=''){
        //   item.name = item.docComments
        // }
        formData.append("file", item);
      });
      fileService.fileUpload(formData).then((res) => {
        console.log(res.data)
        for (let a = 0, len = _this.uploadFileList.length; a < len; a++) {
          if (_this.uploadFileList[a].docComments != '') {
            res.data[a].documentName = _this.uploadFileList[a].docComments + '.' + res.data[a].fileSuffix
          }
          // for (let j = 0,len2=res.data.length;j<len2;j++){
          //   if(_this.uploadFileList[a].docComments!=''){
          //     res.data[j].documentName = _this.uploadFileList[a].docComments
          //   }
          // }
        }
        console.log(res.data)
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.seq = '1';
        attachment.documents = res.data;
        attachment.tsRecId = this.ttMsvReportId;
        attachment.tsReckindId = 'spVisitReport';
        fileService.saveFile(attachment).then((saveRes) => {
          var data = attachment.documents.map(function (item) {
            let obj = {
              fileName: item["documentName"],
              msvNo: _this.queryCondition.msvNo,
              operate: 'UPLOAD',
              ttMsvReportId: _this.ttMsvReportId,
            };
            return obj;
          });
          saveMsvReportFileLogs(data).then(FileLogs => {
          });
          _this.getFiles2();
          _this.uploadFileList = []

        })
      }).catch((error) => {
        //文件上传失败
        this.$message({
          type: "error",
          message: this.$t('common.fileUploadFailed')
        });
      });
    },
    //文件上传
    uploadConfirm: function (item) {
      let file = item.file
      file.docComments = ''
      this.uploadFileList.push(file);
    },
    handlePreview(file) {
      console.log(file);
    },
    init() {
      let that = this;
      // getVisitReportList(that.queryCondition).then(res => {
      //   console.log(res)
      //   let list = res.resultData
      //   for (let i = 0,len=list.length;i<len;i++){
      //     list[i].ids = i
      //   }
      //   this.tableList = list
      // });
      addVisitPlanReportInit().then(res => {
        // this.$set(that.queryCondition.msv, "msvNo", res.data);
        that.queryCondition.msvNo = res.data
      });
    },
    //获取MSV_REPOR_CQS文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttMsvReportId;
      attachment.tsReckindId = 'MSV_REPOR_CQS';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //获取供应商附件
    getFiles2: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttMsvReportId;
      attachment.tsReckindId = 'spVisitReport';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList2 = fileRes;
      })
    },
    getDetail(id) {
      let that = this;
      reportDetail(id).then(res => {
        console.log(res)
        let list = res.data.msvReportDetails
        for (let i = 0, len = list.length; i < len; i++) {
          list[i].ids = i
        }
        that.tableList = list
        that.queryCondition.msvNo = res.data.msvNo
        that.queryCondition.year = res.data.year
        that.queryCondition.type = res.data.type
        that.queryCondition.supplierCode = res.data.supplierCode
        that.queryCondition.plantName = res.data.plantName
        that.queryCondition.category = res.data.category
        that.queryCondition.tmSupplierId = res.data.tmSupplierId
        that.queryCondition.createBy = res.data.createBy
        that.queryCondition.createDate = this.$options.filters["dateFormatFilter"](res.data.createDate);
        that.queryCondition.visitType = res.data.visitType
        that.queryCondition.supplierEmail = res.data.supplierEmail
        that.queryCondition.mcdEmail = res.data.mcdEmail
        that.queryCondition.attendeesSupplier = res.data.attendeesSupplier
        that.queryCondition.attendeesMcd = res.data.attendeesMcd
        that.queryCondition.mgtRecap = res.data.mgtRecap
        that.queryCondition.msvResult = res.data.msvResult
        that.queryCondition.highScore = res.data.highScore
        that.queryCondition.mediumScore = res.data.mediumScore
        that.queryCondition.capImplementationStatus = res.data.capImplementationStatus
        that.queryCondition.lowScore = res.data.lowScore
        that.queryCondition.capImplementationStatus = res.data.capImplementationStatus
        that.queryCondition.visitBeginDate = res.data.visitBeginDate
        that.queryCondition.visitEndDate = res.data.visitEndDate
        that.createBy = res.data.creater
        if (res.data.visitBeginDate != null) {
          that.$set(that.queryCondition, "visitBeginDate", this.$options.filters["dateFormatFilter"](res.data.visitBeginDate));
          that.$set(that.queryCondition, "visitEndDate", this.$options.filters["dateFormatFilter"](res.data.visitEndDate));
          that.dataArr = [this.$options.filters["dateFormatFilter"](res.data.visitBeginDate), this.$options.filters["dateFormatFilter"](res.data.visitEndDate)];
        }
        let status = res.data.status
        if (status == "FINAL") {
          that.showButton = false//已经提交不能编辑
          that.isdeleteFile = false//已经提交不能删除附件

        }

      });
    },
    saveVisit() {
      let that = this;
      let data = {
        ttMsvReportId: that.ttMsvReportId
      }
      saveSP(that.ttMsvReportId).then(res => {
        if (res.meta.success) {
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
        }
      });
    },
    submitVisitPlan() {
      let that = this;
      if (that.fileList2.length < 1) {
        that.$message({
          type: "error",
          message: that.$t("visitPlan.selectFile")
        });
        return;
      }
      if (that.fileList2.length > 0 && that.uploadFileList.length > 0) {
        that.$message({
          type: "error",
          message: "请将已选择的文件，上传至服务器再提交"
        });
        return;
      }
      let data = {
        ttMsvReportId: that.ttMsvReportId
      }
      submitSP(that.ttMsvReportId).then(res => {
        if (res.meta.success) {
          that.$message({
            message: this.$t("common.submitSuccess"),
            type: "success"
          });
          that.$router.go(-1);
        }
      });
    },
    typeChange(val) {
      if (val == "Food") {
        this.Categorylevel = true;
      } else {
        this.Categorylevel = false;
      }
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    restQueryFormThis2: function () {
      this.$refs.detailAddform.resetFields();
      this.detailAddform.pageSize = 15;
      this.detailAddform.pageNum = 1;
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_MSV:RISK_LEVEL"] = "TT_MSV:RISK_LEVEL";
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:VISIT_TYPE"] = "TT_MSV:VISIT_TYPE";
      mapObj["TT_MSV:CAP_IMPLEMENTATION_STATUS"] = "TT_MSV:CAP_IMPLEMENTATION_STATUS";
      mapObj["TT_MSV:RECAP"] = "TT_MSV:RECAP";
      mapObj["TT_MSV:RESULT"] = "TT_MSV:RESULT";
      mapObj["TT_MSV:VISITPURPOSE"] = "TT_MSV:VISITPURPOSE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.typeList = res["TT_MSV:TYPE"];
        this.riskLevelList = res["TT_MSV:RISK_LEVEL"];
        this.visitTypeList = res["TT_MSV:VISIT_TYPE"];
        this.capImplementationStatusList = res["TT_MSV:CAP_IMPLEMENTATION_STATUS"];
        this.mgtRecapList = res["TT_MSV:RECAP"];
        this.msvResultList = res["TT_MSV:RESULT"];
        this.visitPurposeList = res["TT_MSV:VISITPURPOSE"];
        // this.restaurant  = res["TT_MSV:VISITPURPOSE"];
        // console.log(this.restaurant)
      });
    },
    goBack() {
      this.$router.push({ name: 'visitReportSp' });
    },
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.inputClass {
  position: relative;
}
.visitReportSpDetail .el-upload-list__item-thumbnail {
  width: 100%;
  line-height: 100px;
  font-size: 50px;
  text-align: center;
}
.visitReportSpDetail .fileName {
  height: 100px;
  text-align: center;
  display: block;
}

.el-table {
  margin-top: 10px;
}
.searchBox_top {
  margin-bottom: 20px;
}
.tip {
  color: #1f2f3d;
  margin-bottom: 5px;
  display: block;
}
.tipText span {
  color: red;
  font-size: 14px;
  display: block;
}
.miaoshu {
  position: absolute;
  z-index: 99;
  left: 0;
  width: 75%;
  border-color: #f8ab01;
  color: #000;
  bottom: 20%;
  border-radius: 4px;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
}
.el-upload-list--picture-card .el-upload-list__item-actions {
  z-index: 88;
}
.purposeList {
  .el-table__row {
    td:nth-child(3) {
      .cell {
        width: 90%;
        .el-autocomplete {
          width: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.visitReportSpDetail {
  .el-form-item {
    width: 500px;
  }
  .el-date-editor {
    width: 100%;
  }
  .el-form-item__content {
    width: 240px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  .searchBox .el-input--small .el-input__inner {
    width: 200px;
  }
  .ScoreClass {
    width: 280px;
    .el-form-item__content {
      width: 150px;
    }
    .el-form-item__label {
      width: 110px !important;
    }
  }
  .highScoreClass {
    width: 420px;
    .el-form-item__content {
      width: 150px;
    }
  }
}
</style>
